import styled from 'styled-components';

import { themeGet } from 'ravenjs/utils/theme';

const DataGridStyled = styled.div`
    position: relative;
    width: 100%;
    min-height: 1px;
    /**
     * Add all of the remaining styles from theme
     */
    ${themeGet('DataGrid.styles')};
`;

export default DataGridStyled;
